export const returnServiceType = (serviceTypes, type, locale) => {
  if (serviceTypes[type]) {
    return serviceTypes[type][locale];
  }
  return type;
};
